import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { getLocationTracker } from '../services/locationTracker';

/**
 * Resumes live tracking (or the upload of saved points) after the app is
 * relaunched during a client visit. Renders nothing; the server confirms the
 * visit is still open before recording continues.
 */
export function LocationTrackingBootstrap() {
  const { status, user } = useAuth();
  const userId = user?.userId != null ? String(user.userId) : null;
  useEffect(() => {
    if (status !== 'authenticated' || !userId) return;
    void getLocationTracker()
      .resume(userId)
      .catch(() => undefined);
  }, [status, userId]);
  return null;
}
